import { createApi } from '@reduxjs/toolkit/query/react'

import { getBaseQueryWithMockError } from '@/shared/api/custom-fetch-base'

import { IService } from '../types'

const mock = [
  {
    id: 1,
    name: 'Аналитика',
    label: 'Сервис для анализа деятельности на маркетплейсах',
    description:
      'На основе данных о товарах показывает отчеты, графики и метрики. Помогает принимать решения для эффективного управления бизнесом',
    needToken: true,
  },
  {
    id: 2,
    name: 'Языковая модель',
    label: 'Подзаголовок',
    description: 'текст',
    needToken: false,
  },
  {
    id: 3,
    name: 'Робот цен',
    label: 'Продукт для управления ценами на маркетплейсах',
    description:
      'Позволяет рассчитывать комиссии маркетплейсов, учитывать цены конкурентов и составлять формулы расчета ценообразования',
    needToken: true,
  },
]

export const serviceApi = createApi({
  reducerPath: 'serviceApi',
  baseQuery: getBaseQueryWithMockError(mock),
  tagTypes: ['services'],
  endpoints: build => ({
    listService: build.query<IService[], void>({
      query: () => ({
        url: 'services',
        method: 'GET',
      }),
      providesTags: ['services'],
    }),
  }),
})

export const { useListServiceQuery } = serviceApi
